import {
  Bar,
  BarChart,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { formatNumber } from "@/features/reports/lib/format";
import { fa } from "../i18n/fa";

export default function GeoBarChart({
  rows,
  selectedCode,
  showAll,
  hideEmpty,
  onToggleAll,
}) {
  const ranked = [...rows]
    .filter((row) => !hideEmpty || row.kg > 0 || row.code === selectedCode)
    .sort((left, right) => right.kg - left.kg);
  const filtered = selectedCode
    ? ranked.filter((row) => row.code === selectedCode)
    : ranked;
  const visible = showAll || selectedCode ? filtered : filtered.slice(0, 10);

  return (
    <>
      <div className="tr-geo-chart-actions">
        <span>{fa.geo.absoluteKg}</span>
        {!selectedCode && (
          <button type="button" className="tr-geo-text-button" onClick={onToggleAll}>
            {showAll ? fa.geo.topTen : fa.geo.showAll}
          </button>
        )}
      </div>
      {visible.length ? (
        <div className="tr-geo-bars-scroll">
          <div className="tr-geo-bars" style={{ height: Math.max(300, visible.length * 35) }}>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                data={visible}
                layout="vertical"
                margin={{ top: 4, right: 12, left: 8, bottom: 4 }}
              >
                <XAxis type="number" tickFormatter={formatNumber} />
                <YAxis
                  type="category"
                  dataKey="name"
                  width={160}
                  tick={{ fontSize: 12 }}
                  interval={0}
                  reversed
                />
                <Tooltip
                  formatter={(value) => [fa.geo.kg(value), fa.geo.volume]}
                  labelFormatter={(name) => name}
                />
                <Bar dataKey="kg" name={fa.geo.volume} radius={[4, 4, 4, 4]}>
                  {visible.map((row) => (
                    <Cell
                      key={row.code}
                      fill={row.code === selectedCode ? "#F59E0B" : "var(--green)"}
                    />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      ) : (
        <div className="tr-empty"><p>{fa.geo.noRecords}</p></div>
      )}
    </>
  );
}
